
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Textarea } from '@/components/ui/textarea';
import { Sparkles } from 'lucide-react';

interface PromptsTabContentProps {
  editing: boolean;
}

const PromptsTabContent: React.FC<PromptsTabContentProps> = ({ editing }) => {
  return (
    <div className="grid gap-4">
      <div className="grid gap-2">
        <Label htmlFor="system-prompt">Default System Prompt</Label>
        <Textarea
          id="system-prompt"
          className="min-h-[120px] w-full resize-y"
          placeholder="Enter system prompt that defines AI assistant behavior"
          disabled={!editing}
          defaultValue="You are an energy management assistant. Provide concise, accurate information about energy usage, optimization strategies, and device health."
        />
      </div>
      
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label htmlFor="prompt-history">Store Prompt History</Label>
          <p className="text-sm text-muted-foreground">Save prompts for future reference and improvement</p>
        </div>
        <Switch 
          id="prompt-history" 
          checked={true} 
          disabled={!editing}
        />
      </div>
    </div>
  );
};

export default PromptsTabContent;
